import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

const HashMono = ({ hash, chars = 8, full = false, className = '' }) => {
  const [copied, setCopied] = useState(false);
  const display = full ? hash : `${hash.slice(0, chars)}...${hash.slice(-4)}`;

  const copy = () => {
    navigator.clipboard.writeText(hash);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={copy}
      className={`inline-flex items-center gap-1.5 font-mono text-xs text-cyan/80 hover:text-cyan transition-colors duration-fast group ${className}`}
      aria-label={`Copy hash ${hash.slice(0, 8)}`}
    >
      <code>{display}</code>
      {copied
        ? <Check className="w-3 h-3 text-success" />
        : <Copy className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-fast" />
      }
    </button>
  );
};

export default HashMono;
